
/**
 * 
 * @param el 
 * @param str 
 */
export const hasClass = (el: Element | null, str: string) => { 
  if (!el){
    return false
  }

  return el.classList.contains(str); 
};
